import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

// obsolete code
import React from 'react';
import { PureComponent } from '../component';
import { uploadClass } from './styles';
import Drop from './Drop';
import { accept as attrAccept } from '../utils';

var Dragger =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Dragger, _PureComponent);

  var _super = _createSuper2(Dragger);

  function Dragger(props) {
    var _this;

    _classCallCheck(this, Dragger);

    _this = _super.call(this, props);
    _this.handleDrop = _this.handleDrop.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Dragger, [{
    key: "getMatchedFile",
    value: function getMatchedFile() {
      var files = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var accept = this.props.accept;
      return Array.prototype.slice.call(files).filter(function (file) {
        return attrAccept(file, accept);
      });
    }
  }, {
    key: "handleDrop",
    value: function handleDrop(files) {
      var addFile = this.props.addFile;
      addFile({
        files: files,
        fromDragger: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          disabled = _this$props.disabled,
          multiple = _this$props.multiple,
          limit = _this$props.limit,
          accept = _this$props.accept;
      return (
        /*#__PURE__*/
        React.createElement(Drop, {
          className: uploadClass('dragger-wrapper'),
          drop: true,
          disabled: disabled,
          multiple: multiple || limit > 1,
          accept: accept,
          onDrop: this.handleDrop
        },
        /*#__PURE__*/
        React.createElement("div", {
          className: uploadClass('dragger-area', disabled && 'disabled')
        }, children))
      );
    }
  }]);

  return Dragger;
}(PureComponent);

export default Dragger;